var Utils = require("common/Utils");

/**
 * @constructor
 */
function TOTPEnrollmentView() {
    var self = this;

    var $content = $(require("html!./totp_enrollment_view.html"));
    var $qrElement = $content.find("#totpQRCode");
    var $link = $content.find(".qrCodeContainer a");
    var $verificationCodeInput = $content.find("#verificationCode");

    var $saveButton = $('<a data-role="button" data-icon="mobile-confirm" data-iconpos="notext" data-inline="true">');

    // Add click event to select entire secret key (user-select=all does not work on some browsers)
    $content.find("#totpSecretKey").on("click", function() {
        $(this).select();
    });

    function submitFn() {
        var verificationCode = $verificationCodeInput.val();

        self.publishEvent("TOTPSettingsDelegate", "submit-enrollment-code", {verificationCode : verificationCode});
    }
    Utils.registerKeyboardSubmit($verificationCodeInput, submitFn);
    $saveButton.on("click", submitFn);

    $verificationCodeInput.on("change cut paste input", function(event) {
        var val = $(this).val();

        if (event.originalEvent.clipboardData) {
            var element = event.target;

            if (element && element.selectionStart) {
                var clipboardData = event.originalEvent.clipboardData.getData("text");

                if (element.selectionStart == element.selectionEnd) {
                    val += clipboardData;
                } else {
                    val = [val.slice(0, element.selectionStart), clipboardData, val.slice(element.selectionEnd)].join("");
                }
            } else {
                val = event.originalEvent.clipboardData.getData("text");
            }
        }

        if (val.length > 6 || /\D/g.test(val)) {
            return false;
        }

        Utils.setElementEnabled($saveButton, val.length == 6);
    });

    $verificationCodeInput.on("keypress", function(event) {
        // The keycode property has been deprecated, however key is not yet supported on all browsers
        if (event.key != undefined) {
            if (event.key == "Backspace" || event.key == "Delete"
                || event.key == "ArrowLeft" || event.key == "ArrowRight"
                || (event.ctrlKey && event.key == "v")
                || (event.metaKey && event.key == "v")
                || (event.shiftKey && event.key == "Insert")) {
                return true;
            }

            if (isNaN(event.key)) {
                return false;
            }
        } else {
            if (event.keyCode < 48 || event.keyCode > 57) {
                return false;
            }
        }

        var val = $(this).val();

        if (val.length > 5) {
            var element = event.target;

            if (element && element.selectionStart && element.selectionEnd) {
                if (element.selectionStart == element.selectionEnd) {
                    return false; // The input has more than 5 chars in and we are not replacing any of them
                }
            }
        }
    });

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "TOTPEnrollment";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        var session = CudaLaunch.serverConfiguration.getSession();
        var titleLabel;

        if (session.enrolledForTOTP) {
            titleLabel = "common::totp.reEnrollment.title";
        } else {
            titleLabel = "common::totp.enrollment.title";
        }

        return {
            title : $.t(titleLabel),
            i18n : titleLabel,
            rightButtons : [$saveButton]
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "menu";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.isLeafView = function() {
        return true;
    };

    this.setSecretKeyDetails = function(secretKey, username) {
        $content.find("#totpSecretKey").val(secretKey);
        const encodedIssuer = encodeURIComponent(Utils.getServerProductName(CudaLaunch.serverConfiguration.version));
        const encodedUsername = encodeURIComponent(username);

        const uri = "otpauth://totp/" + encodedIssuer + ":" + encodedUsername + "?secret=" + secretKey + "&issuer=" + encodedIssuer;
        $qrElement.empty();
        $qrElement.qrcode({
            text : uri,
            width : 200,
            height : 200
        });
        $link.attr("href", uri);
    };

    var super_show = this.show;
    this.show = function() {
        $verificationCodeInput.val("");
        Utils.setElementEnabled($saveButton, false);

        super_show.call(this);
    };
}

TOTPEnrollmentView.prototype = require("common/AbstractView");

module.exports = TOTPEnrollmentView;


//////////////////
// WEBPACK FOOTER
// ./settings/totp/TOTPEnrollmentView.js
// module id = 92
// module chunks = 0 3